import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import NProgress from 'nprogress'
import { setupRouterGuards } from './guards'
import 'nprogress/nprogress.css'

// 路由模块
import dashboardRoutes from './modules/dashboard'
import userRoutes from './modules/user'
import contractRoutes from './modules/contract'
import listingsRoutes from './modules/listings'
import issuerRoutes from './modules/issuerProfiles'
import inventoryRoutes from './modules/inventory'
import announcementRoutes from './modules/announcements'
import opsRoutes from './modules/ops'
import tradeRoutes from './modules/trade'
import riskRoutes from './modules/risk'
import fundRoutes from './modules/fund'
import systemRoutes from './modules/system'

NProgress.configure({ showSpinner: false })

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/layouts/default.vue'),
    redirect: '/dashboard',
    children: [
      ...dashboardRoutes,
      ...userRoutes,
      ...contractRoutes,
      ...listingsRoutes,
      ...issuerRoutes,
      ...inventoryRoutes,
      ...announcementRoutes,
      ...opsRoutes,
      ...tradeRoutes,
      ...riskRoutes,
      ...fundRoutes,
      ...systemRoutes,
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

// 设置路由守卫
setupRouterGuards(router)

export default router
